class FaqTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.faq-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.faq-tabs__panel'));
    if (this.tabs.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab.dataset.category));
      tab.addEventListener('keydown', this.onKeyDown.bind(this));
    });
  }

  select(category) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.category === category;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.category !== category;
    });
  }

  onKeyDown(event) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) return;
    event.preventDefault();

    const current = this.tabs.indexOf(event.currentTarget);
    let next = current;

    if (event.key === 'ArrowLeft') next = current === 0 ? this.tabs.length - 1 : current - 1;
    if (event.key === 'ArrowRight') next = current === this.tabs.length - 1 ? 0 : current + 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.tabs.length - 1;

    this.select(this.tabs[next].dataset.category);
    this.tabs[next].focus();
  }
}

if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', FaqTabs);
}
